<script setup>
import CategorySelector from "@/components/table/CreateFeed/CategorySelector.vue";
import {onMounted, ref} from "vue";
import {useSources} from "@/stores/sources-store";

const sourcesStore = useSources();

const props = defineProps({
  tagList: {
    type: [Array, null],
    required: true,
    default: null
  }
});

onMounted( async () => {
  categories.value = await sourcesStore.getTagsCategories();

  if (props.tagList) {
    tagList.value = props.tagList;
    tagIds.value = props.tagList.map((tag) => tag.tag_active.id);
  }

  if (tagList.value.length === 0) {
    tagList.value = [{category_active: "Без категории", tag_list: [], tag_active: []}];
    await selectCategory(0, "");
  }
});

const tagIds = ref([]);

const emit = defineEmits(["update-tag-ids"]);

const categories = ref([]);

const tagList = ref([]);

const addCategory = async () => {
  tagList.value.push({category_active: "Без категории", tag_list: [], tag_active: []});
  await selectCategory(tagList.value.length - 1, "");
};

const selectCategory = async (index, selectedCategory) => {
  tagList.value[index].category_active = selectedCategory;
  tagList.value[index].tag_list = (await sourcesStore.getTagByCategory(selectedCategory))
    .sort((a, b) => a.name.localeCompare(b.name));
};

const deleteCategory = (index) => {
  if (tagList.value[index].tag_active.id) {
    const tagIdIndex = tagIds.value.indexOf(tagList.value[index].tag_active.id);
    if (tagIdIndex !== -1) {
      tagIds.value.splice(tagIdIndex, 1);
      emit("update-tag-ids", tagIds.value);
    }
  }
  tagList.value.splice(index, 1);
};


const selectedCategoryTag = (index, tag) => {
  // Если ранее уже был выбран тег
  if (tagList.value[index].tag_active.id) {
    tagIds.value.splice(tagIds.value.indexOf(tagList.value[index].tag_active.id), 1);
  }

  tagList.value[index].tag_active = tag;
  tagIds.value.push(tag.id);  
  emit("update-tag-ids", tagList.value[index].tag_active);
};

</script>

<template>
  <div class="tag-selector">
    <div class="tag-selector__title">
      Теги
    </div>

    <div class="tag-selector__list">
      <div class="tag-selector__item">
        <div class="item__category">
          <CategorySelector
            v-for="(category, index) in tagList"
            :key="index"
            :tag-list="category.tag_list"
            :selected="category.category_active"
            :selected-tag="category.tag_active"
            :items="categories"
            @select-category-tag="args => selectedCategoryTag(index, args)"
            @delete-category="deleteCategory(index)"
            @select-category="selectedCategory => selectCategory(index, selectedCategory)"
          />
        </div>
      </div>
    </div>
    <div
      class="tag-selector__add-category"
      @click="addCategory"
    >
      Добавить категорию
    </div>
  </div>
</template>

<style scoped lang="scss">
.tag-selector {
  display: flex;
  flex-direction: column;
  padding: 24px;
  border-radius: 8px;
  background: #F7F8FD;
  gap: 24px;

  &__add-category {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    padding: 6.4px 15px;
    border: 1px solid #1A64D4;
    color: #1A64D4;
    background: #FFFFFF00;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    user-select: none;

    &:hover {
      background: #E0F0FF;
      border-color: #E0F0FF;
    }
  }

  .item__category {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  &__title {
    font-size: 16px;
    font-weight: 500;
    color: #7B87A5;
  }
}

</style>